<template>
  <div class="header" :class="{mobile: $appUtils.isMobile(), 'show-back': $router.currentRoute.path !== '/dashboard'}">
    <span class="title ellipsis" v-if="!$appUtils.isMobile()">Gestão Agrisoy</span>
    <div class="title ellipsis" v-else>{{ screenTitle }}</div>

    <a @click="$router.go(-1)" v-ripple-tap v-if="$appUtils.isMobile()" class="back-button">
      <svg-icon icon="chevron-left"/>
    </a>

    <router-link v-if="showHome()" v-ripple-tap to="/dashboard" class="home">
      <svg-icon icon="home"/>
    </router-link>

    <div class="actions" v-if="$appUtils.isDesktop()">
      <router-link to="/market_places" v-ripple-tap title="Market Places" class="btn btn-primary btn-theme-1">
        <svg-icon icon="book-open"/>
        Market Place
      </router-link>
      <button type="button" v-ripple-tap @click="showFinMov"
              v-if="$appStorage.userIsProfile(['admin', 'admin_all', 'admin_view', 'backoffice'])"
              title="Lançamento Financeiro" class="btn btn-dark">
        <svg-icon icon="cash-register"/>
      </button>
      <button type="button" v-ripple-tap @click="addFile" title="Arquivos de Clientes" class="btn btn-secondary">
        <svg-icon icon="file-alt"/>
      </button>
      <router-link to="/users/profile" v-ripple-tap title="Meu Perfil" class="btn btn-primary btn-profile">
        <svg-icon icon="id-card"/>
      </router-link>
      <button type="button" v-ripple-tap class="btn btn-primary btn-sunny-orange w-s-n" title="Agribot" @click="showAgribot">
        <svg-icon icon="robot-solid"/>
      </button>
      <button type="button" v-ripple-tap class="btn btn-danger w-s-n" title="Sair do Sistema" @click="signOut">
        <svg-icon icon="sign-out-alt"/>
      </button>
    </div>
  </div>
</template>

<script>
import {EventBus} from "@/utils/EventBus"
import {createNamespacedHelpers, mapGetters, mapMutations} from 'vuex'

const usersStore = createNamespacedHelpers('users');

export default {
  name: "Header",
  methods: {
    ...mapMutations(['addModal', 'destroyModal']),
    ...usersStore.mapActions(['logout']),
    showHome() {
      return this.$router.currentRoute.path !== '/dashboard' && this.$appUtils.isMobile()
    },
    addFile() {
      EventBus.showCustomerGroupFile(() => {
      }, {});
    },
    showAgribot() {
      EventBus.showAgribot(() => {
      }, {});
    },
    showFinMov() {
      EventBus.showFinMov(() => {
      }, {entity: {}});
    },
    signOut() {
      this.addModal({
        title: 'Sair do Sistema',
        size: 'small',
        body: 'Deseja realmente sair do sistema?',
        buttons: [{
          type: 'ok',
          class: 'btn btn-theme-1 btn-sm',
          method: id => {
            this.destroyModal(id);
            this.logout();
          }
        }, {
          type: 'close',
          label: 'Não',
          method: this.destroyModal
        }
        ]
      });
    }
  },
  computed: {
    ...mapGetters(['screenTitle'])
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables";

.header {
  display: grid;
  grid-template-columns: 300px auto;
  justify-items: start;
  align-items: center;
  background: $theme_color_seven;
  height: 100%;
  border-bottom: 1px solid $theme_color_nine;
  grid-template-areas: 'title actions';

  .title {
    padding-left: 10px;
    font-weight: 400;
    color: $theme_color_eight;
    grid-area: title;
    max-width: 100%;
  }

  .back-button {
    display: none;
  }

  .actions {
    grid-area: actions;
    justify-self: end;

    .btn {
      color: #fff;
      margin-right: 5px;
    }
  }

  &.mobile {
    background: $theme_color_six;
    border-bottom: none;

    .title {
      color: $theme_color_four;
    }

    &.show-back {
      display: grid;
      grid-template-columns: 50px auto 50px;
      grid-template-areas: "back title home";
      justify-items: center;

      .title {
        text-align: center;
        color: $theme_color_four;
        padding-right: 10px;
      }

      .back-button, .home {
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        grid-area: back;
        padding-left: 10px;
        width: 100%;
        height: 100%;

        svg {
          color: white;
          width: 1em;
          height: 1em;
        }
      }

      .home {
        grid-area: home;
        text-align: center;
        padding-left: 0;

        svg {
          color: white;
          width: 1.5em;
          height: 1.5em;
        }
      }
    }
  }
}
</style>
